import { render, staticRenderFns } from "./ModelConfig.vue?vue&type=template&id=8f92284a"
import script from "./ModelConfig.vue?vue&type=script&lang=js"
export * from "./ModelConfig.vue?vue&type=script&lang=js"
import style0 from "./ModelConfig.vue?vue&type=style&index=0&id=8f92284a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports